import React from 'react';
import { Tooltip, Button } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { colorConstants } from 'config/colorConstants';

interface AutoPopulateIconProps {
    onPopulate: () => void;
    tooltip?: string;
    disabled?: boolean;
    className?: string;
}

const AutoPopulateIcon: React.FC<AutoPopulateIconProps> = ({
    onPopulate,
    tooltip = 'Auto-populate field',
    disabled = false,
    className = '',
}) => {
    return (
        <Tooltip title={tooltip}>
            <Button
                type="text"
                icon={<ThunderboltOutlined style={{ color: colorConstants.purpleFont }} />}
                onClick={onPopulate}
                disabled={disabled}
                className={`p-1 h-auto min-w-0 ${className}`}
                size="small"
            />
        </Tooltip>
    );
};

export default AutoPopulateIcon;
